import { render, staticRenderFns } from "./ChipsFast.vue?vue&type=template&id=4938e979&"
import script from "./ChipsFast.vue?vue&type=script&lang=js&"
export * from "./ChipsFast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports